import { Expertises } from '@platform/client';
import { MultiSelectCategory, MultiSelectCategoryDropdown } from '@platform/components';
import { Placement } from 'react-aria';
import { UseFormRegisterReturn } from 'react-hook-form';

type SkillsSelectionDropdownProps = {
  selectedSkills: string[];
  onSkillsSelectionChange: (skills: string[]) => void;
  register?: () => UseFormRegisterReturn<string>;
  errors?: Record<string, { message: string } | undefined>;
  label: string|React.ReactNode;
  subLabel?: string|React.ReactNode;
  placeholder?: string;
  selectionLimit?: number;
  placement?: Placement,
  mobile?: boolean,
};
export const SkillsSelectionDropdown = ({
  selectedSkills,
  onSkillsSelectionChange,
  register,
  errors,
  placeholder,
  label,
  subLabel,
  selectionLimit,
  placement,
  mobile,
}: SkillsSelectionDropdownProps) => {
  const expertisesList = Expertises.useGetExpertises();

  const classificationOptions =
    expertisesList.isSuccess ?
      Array.from(
        expertisesList.data
          .reduce<Map<string, MultiSelectCategory>>((map, expertise) => {
            if (!map.has(expertise.classification)) {
              map.set(expertise.classification, {
                name: expertise.classification,
                options: [],
              });
            }
            /* eslint-disable-next-line */
            map.get(expertise.classification)!.options.push(expertise.name);
            return map;
          }, new Map())
          .values(),
      )
    : [];

  return (
    <MultiSelectCategoryDropdown
      categories={classificationOptions}
      label={label}
      subLabel={subLabel}
      selectionLimit={selectionLimit || 5}
      placeholder={placeholder || 'Select skills'}
      selectedItems={selectedSkills}
      onSelectionChange={onSkillsSelectionChange}
      error={errors?.skills?.message}
      register={register}
      placement={placement}
      mobile={mobile}
    />
  );
};
